<template>
  <div id="indexHomePage">
    <!-- 头部 -->
    <div class="head_top">
      <transition name="el-zoom-in-top">
        <div class="pull-down" v-if="!iconShow">
          <span
            @click="
              statisticJump();
              iconShow = true;
            "
            >进入大屏</span
          >
          <span
            @click="
              outLogin();
              iconShow = true;
            "
            >退出登录</span
          >
          <span
            @click="
              dialogVisible = true;
              iconShow = true;
            "
            >修改密码</span
          >
        </div>
      </transition>
      <div
        v-if="JSON.stringify($store.state.userInfo) != '{}'"
        class="head_top_yes"
      >
        <span>{{ $store.state.userInfo.account }}</span>
        <img src="../../assets/avatar.png" alt="" />
        <i
          :class="iconShow ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"
          @click="iconShow = !iconShow"
        ></i>
      </div>
      <div v-else class="head_top_yes1" @click="handleLogin">
        <span>登录</span>
      </div>
    </div>
    <!-- logo -->
    <div class="head_company">
      <div class="company_logo">
<!--        <img src="../../assets/indexImg/companyLogo.png" alt="" />-->
      </div>
    </div>
    <!-- 导航路由 -->
    <headerS
      ref="header"
      v-if="JSON.stringify($store.state.userInfo) != '{}'"
    ></headerS>
    <!-- 面包屑 -->
    <breadcrumb v-if="show" ref="breadcrumb"></breadcrumb>
    <!-- 菜单 -->
    <div
      :class="
        $route.path !== '/homePage'
          ? 'menu_item_body'
          : 'menu_item_body_recover'
      "
    >
      <router-view />
    </div>
    <div class="index_bottom">
      <div>
        Copyright © 2023 NXSYZT.All Rights Reserved.
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中卫市职业技术学校 版权所有
      </div>
      <!-- <div>服务热线：400-425-899</div> -->
    </div>
    <!--修改密码-->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="true"
      :close-on-click-modal="true"
      router-dialogDrag
    >
      <el-form
        :model="model"
        :rules="rule"
        ref="registerRef"
        label-width="160px"
      >
        <el-form-item label="原密码" prop="srcPassword">
          <el-input v-model.trim="model.srcPassword" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model.trim="model.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="再次输入新密码" prop="confirmPassword">
          <el-input
            v-model.trim="model.confirmPassword"
            type="password"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitForm('registerRef')"
          v-preventReClick
          >确 定</el-button
        >
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import crumbs from "../../components/crumbs/crumbs.vue";
import headerS from "./headerS.vue";
import breadcrumb from "./breadcrumb.vue";
export default {
  components: { crumbs, headerS, breadcrumb },
  data() {
    return {
      iconShow: true,
      show: false,
      dialogVisible: false,
      model: {},
      rule: {
        srcPassword: {
          required: true,
          message: "请输入原密码",
          trigger: "blur",
        },
        password: {
          required: true,
          message: "请输入新密码",
          trigger: "blur",
        },
        confirmPassword: {
          required: true,
          message: "请再次输入新密码",
          trigger: "blur",
        },
      },
    };
  },
  watch: {
    $route() {
      if (
        this.$route.path == "/homePage" ||
        this.$route.path == "/newsDetails" ||
        this.$route.path == "/newsPage"
      ) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
  },
  mounted() {},
  methods: {
    // 面包屑
    breadcrumbS(data) {
      if (data.path !== "/homePage") {
        this.show = true;
        this.$nextTick(() => {
          this.$refs.breadcrumb.init(data);
        });
      } else {
        this.show = false;
      }
    },
    /* 跳转大屏 */
    statisticJump() {
      window.open(
        this.$config.LargeScreen +
          "?" +
          "token=" +
          localStorage.getItem("Token") +
          "&",
        "_blank"
      );
    },
    // 登录系统
    handleLogin() {
      this.$router.push({
        path: "/login",
      });
    },
    // 退出登录
    outLogin() {
      this.$refs.header.menuData = [{ label: "首页", path: "/homePage" }];
      this.$confirm("确定退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.clear();
          this.$store.commit("removeUserInof");
          this.$router.push({
            path: "/homePage",
          });
          this.show = false;
          this.$message({
            type: "success",
            message: "退出成功!",
          });
        })
        .catch(() => {});
    },
    submitForm(formName) {
      if (this.model.password == this.model.confirmPassword) {
        this.$refs[formName].validate((valid) => {
          delete this.model.confirmPassword;
          this.model.userId = this.$store.state.userInfo.roleId;
          if (valid) {
            this.$http
              .postRequest("/user/updatePassword", this.model)
              .then((res) => {
                if (res.data.code == 200) {
                  this.dialogVisible = false;
                  this.$message.success("修改成功！请重新登陆");
                  this.$store.commit("removeUserInof");
                  this.$router.push({
                    path: "/",
                  });
                } else {
                  this.$message.warning(res.data.msg);
                }
              });
          }
        });
      } else {
        this.$message.warning("两次密码输入不统一！请重新输入");
        this.$set(this.model, "password", "");
        this.$set(this.model, "confirmPassword", "");
        this.$set(this.model, "srcPassword", "");
      }
    },
  },
};
</script>

<style scoped lang="less">
#indexHomePage {
  width: 100%;
  background: url("../../assets/banner.png") no-repeat;
  background-size: 100% 450px;
}
::v-deep .el-divider--vertical {
  border-radius: 10px;
  background-color: red;
  width: 2px !important;
}
::v-deep .el-dropdown {
  cursor: pointer;
}
::v-deep .el-dropdown:hover {
  color: #409eff;
}
.head_top {
  // height: 60px;
  // position: absolute;
  width: 100%;
  .head_top_yes1 {
    margin-right: 35px;
    margin-top: 22px;
    float: right;
    min-width: 84px;
    height: 35px;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 18px;
    text-align: center;
    line-height: 35px;
    color: #3a3a3a;
    font-size: 16px;
    cursor: pointer;
  }
  .head_top_yes {
    margin-right: 35px;
    margin-top: 22px;
    float: right;
    min-width: 158px;
    height: 35px;
    background: rgba(255, 255, 255, 0.4);
    border-radius: 18px;
    padding-left: 10px;
    display: flex;
    justify-content: center;
    line-height: 35px;
    color: #3a3a3a;
    font-size: 18px;
    img {
      margin-left: 10px;
      margin-top: 5px;
      width: 25px;
      height: 25px;
    }
    i {
      margin-left: 10px;
      margin-top: 10px;
      color: #3a3a3a;
      cursor: pointer;
    }
  }
  .pull-down {
    position: absolute;
    top: 60px;
    right: 40px;
    width: 80px;
    height: 100px;
    border-radius: 8px;
    background: rgba(182,188,198, 0.9);
    padding-top: 10px;
    z-index:2024;
    span {
      margin: 5px 0;
      display: block;
      text-align: center;
      font-size: 15px;
      color: #3a3a3a;
      cursor: pointer;
    }
    span:hover {
      color: red;
    }
  }
}
.head_company {
  width: 100%;
  height: 60px;
  //background-image: url("../../assets/indexImg/indeBg.png");
  //background-size: 100% 25%;
  //background-attachment: fixed;
  padding: 0 15%;
  .company_logo {
    height: 100%;
    padding-top: 25px;
    img {
      width: 372px;
      height: 40px;
    }
  }
}
.no_login {
  height: 4px;
  margin: 10px 0;
  width: 100%;
  background-color: #aa0000;
}
.menu_item_body {
  margin: 0px 15% 10px 15%;
  height: 100%;
}
.menu_item_body_recover {
  margin-top: 41px;
  height: 100%;
}
.friendly_link {
  height: 100px;
  //width: 81.5%;
  margin: 40px 15% 10px 15%;
  background-color: #eeeeee;
  .link_title {
    padding: 13px 22px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #aa0000;
  }
  .link_hr {
    width: 36px;
    height: 3px;
    background: #aa0000;
    border: 0px;
    margin-top: -13px;
    margin-left: 22px;
    float: left;
  }
  .link_main {
    margin-left: 22px;
    margin-top: 10px;
    display: flex;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    ::v-deep .el-divider--vertical {
      background: #acacac;
      margin-right: 13px;
    }
    .item {
      cursor: pointer;
    }
    .item:hover {
      color: blue;
      text-decoration: underline;
    }
  }
}
.index_bottom {
  margin-top: 20px;
  text-align: center;
  height: 50px;
  width: 100%;
  background-color: #cfcfcf;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 40px;
  padding-top: 12px;
  word-spacing: 2px;
}

.menu-item-active {
  position: relative;
  width: 157px;

  &::before {
    content: "";
    display: block;
    width: 100%;
    height: 45px;
    background: url("../../assets/indexImg/menu-item-active.png") no-repeat;
    background-size: 100% 100%;
    //position: absolute;
    position: absolute;
    top: -5px;
  }

  //position: sticky;
  //margin-top: -10px !important;
}

.activeDiv {
  height: 40px;
  width: 100%;
  background-color: #aa0000;
  line-height: 40px;
  padding: 0 10%;
  position: relative;
}
</style>
